import React from "react";

export const FirstAid: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="75"
    height="75"
    viewBox="0 0 75 75"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.535714"
      y="0.535714"
      width="73.9286"
      height="73.9286"
      fill="white"
      stroke="#F87171"
      strokeWidth="1.07143"
    />
    <rect x="28.9287" y="10.7144" width="17.1429" height="53.5714" fill="#F87171" />
    <rect
      x="10.7144"
      y="46.0715"
      width="17.1429"
      height="53.5714"
      transform="rotate(-90 10.7144 46.0715)"
      fill="#F87171"
    />
  </svg>
);
